module.exports = __webpack_public_path__ + "static/media/cieloprofondo.bc986ec9.jpg";